import React, { useState, useEffect, useRef, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setFiltros, resetFiltros } from '../../reducers/exame';
import { Formik } from 'formik';
import { useMoment } from '../../hooks';
import axios from 'axios';
import { getHeaders } from '../../request';
import HttpStatus from 'http-status-codes';
import validationSchema from './validationSchema';
import { estadoInicialForm } from './estadoInicialForm';
import { temPerfilRBAC } from '../../secutity/acl';
import { TIPO_ABA_EXAME } from './constantes';
import { open, configure } from '../../reducers/alerta';
import {
    SttGrid,
    SttTranslateHook,
    SttCtrlP,
    SttCard,
    SttCardContent,
    SttCardHeader,
    SttCollapse
} from '@stt-componentes/core';
import { SttButton } from '@stt-componentes/core-v2';
import { PERFIL, MODALIDADE } from '../../common/Constants';
import { NotificationManager } from 'react-notifications';
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { EXAME_PRIORIZADO } from './fieldNames';

import { setPesquisaAvancada } from '../../reducers/exame';
import DataInicialExame from './campos/data-inicial-exame';
import DataFinalExame from './campos/data-final-exame';
import DataInicialLaudo from './campos/data-inicial-laudo';
import DataFinalLaudo from './campos/data-final-laudo';
import SituacaoLaudo from './campos/situacao-laudo';
import SituacaoExame from './campos/situacao-exame';
import Paciente from './campos/paciente';
import Uf from './campos/uf';
import Municipio from './campos/municipio';
import Instituicao from './campos/instituicao';
import Rede from './campos/rede';
import Requisicao from './campos/requisicao';
import Protocolo from './campos/protocolo';
import NumeroExame from './campos/numero-exame';
import ResponsavelEnvio from './campos/responsavel-envio';
import ExamePriorizado from './campos/exame-priorizado';
import MedicoExecutor from './campos/medico-executor';

const useStyles = makeStyles(theme => ({
    card: {
        height: '100%'
    },
    cardAvancado: {
        marginTop: theme.spacing(1)
    },
    buttonWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing(3),
    },
    containerExame: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
    }
}));

const FormPesquisa = (props) => {
    const {
        tipoAba,
        idAba,
        callbackBusca,
        callbackAndamento,
        page,
        count,
        resetPageCount,
        setExamesSelecionados
    } = props;

    const { filtros, listar } = useSelector(state => state.exame);
    const user = useSelector(state => state.index.user);
    const { strings } = useContext(SttTranslateHook.I18nContext);
    const schema = validationSchema(strings);
    const filtrosIniciais = estadoInicialForm(global.gConfig);
    const formRef = useRef();
    const moment = useMoment();
    const classes = useStyles();
    const dispatch = useDispatch();

    const pesquisaAvancada = useSelector(state => state.exame.pesquisaAvancada);

    // Filtros
    const [ufs, setUfs] = useState([]);
    const [filtroPorLocal, setFiltroPorLocal] = useState(false);
    const [filtroPorRede, setFiltroPorRede] = useState(false);
    const [filtroPorFuncionario, setFiltroPorFuncionario] = useState(false);
    const [carregarUfs, setCarregarUfs] = useState(false);

    const UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
    const EXAME_API_BASE_URL = global.gConfig.url_base_exames;

    useEffect(() => {
        if (listar && formRef.current) {
            formRef.current.handleSubmit();
        }
    }, [listar]);

    useEffect(() => {
        if (temPerfilRBAC(user, PERFIL.ADMINISTRADOR) || temPerfilRBAC(user, PERFIL.ADMINISTRADOR_ESTADUAL)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
            setFiltroPorRede(true);
            setFiltroPorFuncionario(true);
        }
        if (temPerfilRBAC(user, PERFIL.MEDICO_SOLICITANTE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
        if (temPerfilRBAC(user, PERFIL.VISUALIZADOR_REDE)) {
            setCarregarUfs(true);
            setFiltroPorLocal(true);
        }
    }, []);

    useEffect(() => {
        if (carregarUfs) {
            let url = `${UTILITARIOS_API_BASE_URL}/localizacao/estado`;
            if (temPerfilRBAC(user, PERFIL.ADMINISTRADOR_ESTADUAL)) {
                const perfil = user.perfisRBAC.filter(p => p.identificador === PERFIL.ADMINISTRADOR_ESTADUAL);
                const estados = perfil[0].estados;
                const idsUf = estados.map(e => e.id);
                url = `${url}?ids=${idsUf.join(',')}`;
            }

            axios
                .get(url, { headers: getHeaders() })
                .then((response) => {
                    if (response.data) {
                        const { itens } = response.data.data;
                        setUfs(itens);
                    }
                })
                .catch(err => console.log(err));
        }
    }, [carregarUfs])

    const gerarFiltroImplicito = (filtros) => {
        switch (tipoAba) {
            case TIPO_ABA_EXAME.INSTITUICAO:
                filtros.instituicao = idAba;
                break;

            case TIPO_ABA_EXAME.PERFIL:
                if (temPerfilRBAC(user, PERFIL.MEDICO_SOLICITANTE)) {
                    filtros.solicitante = user.idFuncionario;
                }
                break;
            case TIPO_ABA_EXAME.REDE:
                filtros.rede = idAba;
                // if (temPerfilRBAC(user, PERFIL.MEDICO_LAUDADOR)) {
                //     filtros.laudador = user.idFuncionario;
                // }
                break;
        }
    }

    const estruturarFiltros = (dados) => {
        let filtrosPesquisa = {
            'sigla-modalidade': MODALIDADE.SIGLA,
            start: dados.start,
            count: dados.count
        };
        gerarFiltroImplicito(filtrosPesquisa);

        if (dados.uf) {
            filtrosPesquisa.uf = dados.uf.id;
        }
        if (dados.municipio) {
            filtrosPesquisa.municipio = dados.municipio.id;
        }
        if (dados.instituicao) {
            filtrosPesquisa.instituicao = dados.instituicao.id;
        }
        if (dados['funcionario-envio']) {
            filtrosPesquisa['funcionario-envio'] = dados['funcionario-envio'];
        }
        if (dados.requisicao) {
            filtrosPesquisa.requisicao = dados.requisicao;
        }
        if (dados.paciente) {
            filtrosPesquisa.paciente = dados.paciente;
        }
        if (dados['cpf-paciente']) {
            filtrosPesquisa['cpf-paciente'] = dados['cpf-paciente'];
        }
        if (dados['cns-paciente']) {
            filtrosPesquisa['cns-paciente'] = dados['cns-paciente'];
        }
        if (dados.rede) {
            filtrosPesquisa.rede = dados.rede.id;
        }
        if (dados['data-exame-de']) {
            filtrosPesquisa['data-exame-de'] = moment(dados['data-exame-de']).format('YYYY-MM-DD');
        }
        if (dados['data-exame-ate']) {
            filtrosPesquisa['data-exame-ate'] = moment(dados['data-exame-ate']).format('YYYY-MM-DD');
        }
        if (dados['data-laudo-de']) {
            filtrosPesquisa['data-laudo-de'] = moment(dados['data-laudo-de']).format('YYYY-MM-DD');
        }
        if (dados['data-laudo-ate']) {
            filtrosPesquisa['data-laudo-ate'] = moment(dados['data-laudo-ate']).format('YYYY-MM-DD');
        }
        if (dados['data-invalidacao-de']) {
            filtrosPesquisa['data-invalidacao-de'] = moment(dados['data-invalidacao-de']).format('YYYY-MM-DD');
        }
        if (dados['data-invalidacao-ate']) {
            filtrosPesquisa['data-invalidacao-ate'] = moment(dados['data-invalidacao-ate']).format('YYYY-MM-DD');
        }
        if (dados['situacao-laudo'].length > 0) {
            filtrosPesquisa['situacao-laudo'] = dados['situacao-laudo'].join('|');
        }
        if (dados.atrasado) {
            filtrosPesquisa.atrasado = dados.atrasado;
        }
        if (dados.protocolo) {
            filtrosPesquisa.protocolo = dados.protocolo;
        }
        if (dados['numero-exame']) {
            filtrosPesquisa['numero-exame'] = dados['numero-exame'];
        }
        if (dados.situacao.length > 0) {
            filtrosPesquisa.situacao = dados.situacao.join('|');
        }
        if (dados['medico-executor']) {
            filtrosPesquisa['medico-executor'] = dados['medico-executor'];
        }
        if (dados[EXAME_PRIORIZADO]) {
            filtrosPesquisa[EXAME_PRIORIZADO] = 'sim';
        }

        return filtrosPesquisa;
    }

    const callbackImpedirImpressao = () => {
        NotificationManager.error(strings.impressaoDesabilitada);
    };

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={filtros}
                validationSchema={schema}
                onSubmit={(data, { setSubmitting }) => {
                    let dataCopy = { ...data };
                    dataCopy.start = page * count;
                    dataCopy.count = count;
                    dataCopy.page = page;
                    setSubmitting(true);
                    callbackAndamento(true);
                    // Salva os parâmetros da pesquisa para manter estado do 
                    // formulário durante a navegação entre páginas
                    dispatch(setFiltros(dataCopy));

                    const params = estruturarFiltros(dataCopy);
                    axios
                        .get(`${EXAME_API_BASE_URL}/exames`, { params: params, headers: getHeaders() })
                        .then((response) => {
                            const dados = response.data.data;
                            callbackBusca(dados);
                        })
                        .catch(err => {
                            callbackBusca({
                                itens: [],
                                totalRegistros: 0
                            });
                            const { response } = err;
                            let tituloAlertaPesquisa = '';
                            let mensagemAlertaPesquisa = '';
                            let msg = strings.mensagemErroGeral;
                            if (response) {
                                if (response.status === HttpStatus.BAD_REQUEST && response.data?.errors) {
                                    const erro = response.data;
                                    let arrMensagem = [];
                                    erro.errors.forEach(error => {
                                        arrMensagem.push(`- ${error.message}`);
                                    });
                                    msg = arrMensagem.join('\n');
                                    tituloAlertaPesquisa = erro.message;
                                    mensagemAlertaPesquisa = msg;
                                } else {
                                    tituloAlertaPesquisa = strings.erro;
                                    mensagemAlertaPesquisa = msg;
                                }
                            } else {
                                tituloAlertaPesquisa = strings.erro;
                                mensagemAlertaPesquisa = msg;
                            }
                            const alertConfig = {
                                title: tituloAlertaPesquisa,
                                message: mensagemAlertaPesquisa,
                                type: 'error',
                                open: true,
                                options: [
                                    {
                                        title: strings.ok,
                                        onClick: () => dispatch(open(false))

                                    }
                                ],
                                onClose: () => dispatch(open(false))
                            };
                            dispatch(configure(alertConfig));
                        })
                        .finally(() => {
                            setSubmitting(false);
                            callbackAndamento(false);
                        });
                }}
            >
                {
                    ({
                        values,
                        isSubmitting,
                        handleSubmit,
                        resetForm
                    }) => {
                        return (
                            <>
                                <form onSubmit={handleSubmit} noValidate>
                                    <SttCtrlP callback={callbackImpedirImpressao} />
                                    <SttGrid container>
                                        <SttGrid item xs={12}>
                                            <SttCard variant="outlined" className={classes.card}>
                                                <SttCardHeader subheader={strings.exame} />
                                                <SttCardContent>
                                                    <SttGrid container spacing={1}>
                                                        <SttGrid item xs={12} sm={4} md={3}>
                                                            <DataInicialExame strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={4} md={3}>
                                                            <DataFinalExame strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={4} md={3}>
                                                            <DataInicialLaudo strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={4} md={3}>
                                                            <DataFinalLaudo strings={strings} />
                                                        </SttGrid>
                                                    </SttGrid>
                                                    <SttGrid>
                                                        <SttGrid className={classes.containerExame} container spacing={1}>
                                                            <SttGrid style={{ marginLeft: '5px' }}>
                                                                <SituacaoExame strings={strings} />
                                                            </SttGrid>
                                                            <SttGrid>
                                                                <SituacaoLaudo strings={strings} />
                                                            </SttGrid>
                                                        </SttGrid>
                                                    </SttGrid>
                                                </SttCardContent>
                                            </SttCard>
                                        </SttGrid>
                                    </SttGrid>
                                    <SttGrid item xs={12} >
                                        <Paciente strings={strings} />
                                    </SttGrid>
                                    <SttGrid className={classes.cardAvancado}>
                                        <SttCollapse in={pesquisaAvancada}>
                                            <SttCard variant="outlined" >
                                                <SttCardHeader subheader={strings.pesquisaAvancada} />
                                                <SttCardContent>
                                                    <SttGrid container spacing={1}>
                                                        {temPerfilRBAC(user, [PERFIL.ADMINISTRADOR, PERFIL.ADMINISTRADOR_ESTADUAL]) && (
                                                            <SttGrid item xs={12} sm={5} md={3} lg={2}>
                                                                <MedicoExecutor strings={strings} />
                                                            </SttGrid>
                                                        )}
                                                        {
                                                            filtroPorLocal &&
                                                            <SttGrid item xs={12} sm={5} md={3} lg={1}>
                                                                <Uf strings={strings} />
                                                            </SttGrid>
                                                        }
                                                        <SttGrid item xs={12} sm={5} md={3} lg={3}>
                                                            <Municipio strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={12} md={3} lg={4}>
                                                            <Instituicao strings={strings} />
                                                        </SttGrid>
                                                        {
                                                            filtroPorRede &&
                                                            <SttGrid item xs={12} sm={6} md={6} lg={2}>
                                                                <Rede strings={strings} />
                                                            </SttGrid>
                                                        }
                                                        <SttGrid item xs={12} sm={4} md={2}>
                                                            <Requisicao strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={4} md={2}>
                                                            <Protocolo strings={strings} />
                                                        </SttGrid>
                                                        <SttGrid item xs={12} sm={4} md={2}>
                                                            <NumeroExame strings={strings} />
                                                        </SttGrid>
                                                        {
                                                            filtroPorFuncionario &&
                                                            <SttGrid item xs={12} sm={4} md={2}>
                                                                <ResponsavelEnvio strings={strings} />
                                                            </SttGrid>
                                                        }
                                                        <SttGrid style={{ marginTop: '12px', marginLeft: '5px' }}>
                                                            <ExamePriorizado strings={strings} />
                                                        </SttGrid>
                                                    </SttGrid>
                                                </SttCardContent>
                                            </SttCard>
                                        </SttCollapse>
                                    </SttGrid>
                                    <SttGrid container spacing={3} className={classes.buttonWrapper}>
                                        <SttGrid item xs={12}>
                                            <SttButton
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                disabled={isSubmitting}
                                                nomarginleft="true"
                                                onClick={resetPageCount}
                                            >
                                                {strings.pesquisar}
                                            </SttButton>
                                            <SttButton
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                disabled={isSubmitting}
                                                onClick={() => {
                                                    dispatch(resetFiltros());
                                                    resetPageCount();
                                                    resetForm({
                                                        values: filtrosIniciais
                                                    });
                                                    callbackBusca(null);
                                                    setExamesSelecionados([]);
                                                }}
                                            >
                                                {strings.limpar}
                                            </SttButton>
                                            <SttButton
                                                type="button"
                                                variant="outlined"
                                                color="secondary"
                                                onClick={() => dispatch(setPesquisaAvancada(!pesquisaAvancada))}
                                            >
                                                {strings.pesquisaAvancada}
                                                {pesquisaAvancada ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </SttButton>
                                        </SttGrid>
                                    </SttGrid>
                                </form>
                            </>
                        )
                    }
                }
            </Formik>
        </>
    );
};

FormPesquisa.propTypes = {
    callbackBusca: PropTypes.func.isRequired,
    callbackAndamento: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    tipoAba: PropTypes.string.isRequired,
    idAba: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    resetPageCount: PropTypes.func.isRequired
};

export default FormPesquisa;